import React from 'react';
import ExternalSvg from 'components/ExternalSvg';
import { AshaIconProps } from '../types';

const AshaDesserts = ({ width = '24px', height = '24px' }: AshaIconProps) => (
  <ExternalSvg customer="asha" iconName="ashaDesserts" width={width} height={height} />
);

export default AshaDesserts;
